export function getJitteredBackoffDelayMs(attempt: number, baseDelayMs: number, maxDelayMs: number): number {
  const cappedDelayMs = Math.min(baseDelayMs * 2 ** Math.max(attempt, 0), maxDelayMs)
  return cappedDelayMs / 2 + Math.random() * cappedDelayMs / 2
}
